import React from 'react';
import {
	LaboratoryWorkplace,
	useLaboratoriesQuery,
	useLaboratoryWorkplacesQuery,
} from '../../../../graphql/graphql';
import Loading from '../../../../Components/Loading';
import LaboratorySetupItem from './LaboratorySetupItem';
// @ts-ignore
import styles from './LaboratorySetup.module.scss';
import Text from '../../../../Components/Base/Text/Text';
import { useAppContext } from '../../../../Services/AppContext';
import ScrollContainer from '../../../Base/Components/ScrollContainer';

interface Props {
	isSuperAdmin: boolean;
}

const LaboratorySetup: React.FC<Props> = ({ isSuperAdmin }) => {
	const { workplaceId } = useAppContext();
	const { data, isLoading } = useLaboratoriesQuery();
	const {
		data: workplaceLaboratoriesData,
		isLoading: workplaceLaboratoriesIsLoading,
		refetch: workplaceLaboratoriesReFetch,
	} = useLaboratoryWorkplacesQuery({ where: { workplaceId } });

	const handleOnChange = () => {
		workplaceLaboratoriesReFetch();
	};

	if (isLoading || workplaceLaboratoriesIsLoading) {
		return <Loading />;
	}

	return (
		<div className={styles.wrapper}>
			<Text className={styles.title} tx='component.laboratorySetup.header' />
			<div className={styles.content}>
				<ScrollContainer>
					{data?.laboratories?.data?.map(laboratory => {
						if (laboratory) {
							const workplaceLaboratory =
								workplaceLaboratoriesData?.laboratoryWorkplaces?.data?.find(
									item => item?.laboratory?.id === laboratory.id,
								) as LaboratoryWorkplace | undefined;
							return (
								<React.Fragment key={laboratory.id}>
									<LaboratorySetupItem
										item={laboratory}
										workplaceLaboratory={workplaceLaboratory}
										workplaceId={workplaceId}
										onChange={handleOnChange}
									/>
								</React.Fragment>
							);
						}
					})}
				</ScrollContainer>
			</div>
		</div>
	);
};

export default LaboratorySetup;
